import {createTheme} from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      light: '#4F535C',
      main: '#7F00FF',
      dark: '#dec7f6',
      contrastText: '#FFFFFF',
      error: '#F16063'
    },
    secondary: {
      light: '#E7E9EE',
      main: '#E7E9EE',
      dark: '#E7E9EE',
      contrastText: '#FFFFFF',
      error: '#F16063'
    },
    test: {
      light: '#448d19',
      main: '#448d19',
      dark: '#448d19',
      contrastText: '#ffffff',
      error: '#448d19'
    },
    action: {
      light: '#657db9',
      main: '#E7E9EE',
      dark: '#E7E9EE',
      contrastText: '#FFFFFF',
      error: '#F16063'
    },
  },
  typography: {
    fontFamily: [
      'Assistant',
      '-apple-system',
      'BlinkMacSystemFont',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
});

export default theme;
